import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
export default {
  data() {
    return {
      // 全局加载框
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        state: null, // 状态
        applicationId: null,
        dataType: null,
        constructionFlagProject: null,
        loginNo: null, // 登录号
        loginPwd: null, // 密码
        relateCode: null, // 项目类别关联代码
        investProjectCode: null, // 投资项目统一代码
        tenderCorpChangeType: null, // 招标人变更类型
        buildCorpName: null, // 现建设单位名称
        buildCorpCode: null, // 现建设单位组织机构代码
        buildCorpAddress: null, // 现建设单位地址
        buildCorpLegal: null, // 现建设单位法定代表人
        buildCorpProperty: null, // 现建设单位单位性质
        buildCorpLinkMan: null, // 现建设单位联系人
        buildCorpLinkTel: null, // 现建设单位联系人电话
        buildCorpLinkMobile: null, // 现建设单位联系人手机
        buildCorpPostalCode: null, // 现建设单位邮编
        buildCorpFax: null, // 现建设单位传真
        buildCorpEMail: null, // 现建设单位电子邮件
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        prjAddress: null, // 工程地点
        prjLargeClass: null, // 工程类别
        prjCategory: null, // 工程小类
        noteNumber: null, // 立项文号
        approveLevel: null, // 立项级别
        approveType: null, // 立项形式
        approveUnit: null, // 批准单位
        totalInvestment: null, // 批准投资总额
        investmentPlanThisYear: null, // 本年度投资计划
        stateProfitInvestment: null, // 国有盈利性投资
        stateNonprofitInvestment: null, // 国有非盈利性投资
        nonstateInvestment: null, // 非国有投资
        foreignInvestment: null, // 外资
        industryClass: null, // 项目行业门类
        industryCode: null, // 项目行业分类
        regulators: null, // 行政监督部门
        projectScale: null, // 工程规模
        constructionType: null, // 报建性质
        constructionGrade: null, // 报建等级
        isKeyProject: null, // 重点工程
        layersFollowingThirtyTwo: null, // 规划建筑层数32层以下
        layersAboveThirtyTwo: null, // 规划建筑层数32层（含）以上
        depthFollowingNine: null, // 深基坑深度9米以下
        depthAboveNine: null, // 深基坑深度9米（含）以上
        heightFollowingOneHundred: null, // 建筑高度100米以下
        heightAboveOneHundred: null, // 建筑高度100米（含）以上
        spanFollowingThirtyTwo: null, // 公共建筑跨度30米以下
        spanAboveThirtyTwo: null, // 公共建筑跨度30米（含）以上
        isRealEstateProject: null, // 是否房地产开发
        isIndustryProject: null, // 是否工业项目
        description: null, // 备注
        opinion: null, // 报建单位意见
        handleOpinion: null, // 办理意见
        constructionFlag: null,
        inputPerson: null,
        inputMode: null,
        insertDate: null,
        updateDate: null,
        firstConstructionId: null, // 原建设方（甲方）报建主键
        firstConstructionNo: null, // 原建设方（甲方）报建编号
        firstConstructionPrjName: null, // 工程名称
        isAudit: null, // 是否需要核验
        digitalSignature: null, // 数字签名
        lockNo: null, // 锁编号
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 主键
      id: null,
      // 操作类型
      controllerFlg: null,
      // 历史查看标志
      historyType: null,
      // 交易目录下拉框
      options: [],
      // 核验表单
      auditForm: {
        id: null,
        recordNumber: null,
        state: null,
        auditType: null,
        auditContent: null,
        lockNo: null,
        digitalSignature: null,
      },
    };
  },

  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 获取标识
    this.controllerFlg = this.$route.query.controllerFlg;
    // 获取历史查看标志
    this.historyType = this.$route.query.historyType;
    // 获取主键
    this.auditForm.recordNumber = this.$route.query.id;
    // 核验主键
    this.auditForm.id = this.$route.query.auditId;
    // 核验类型
    this.auditForm.auditType = this.$route.query.auditType;
    // 默认调用
    this.fun_Open();
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
        // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 如果是历史查看
        if(this.historyType === 'look'){
          // 遍历
          this.formConfigList.map(item => {
            // 遍历
            item.formConfigList.map(e => {
              // 禁止输入
              e.disabled = true;
            })
          })
        }
        // 如果是核验查看
        else{
          // 遍历
          this.formConfigList.map(item => {
            // 遍历
            item.formConfigList.map(e => {
              // 不为核验备注
              if (e.value != 'auditOpinion') {
                // 禁止输入
                e.disabled = true;
              }
            })
          })
        }
        // 查看详情
        this.fun_GetDetail();
      }
    },
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_GetAction("/supConstruction/detail", {
        id: this.auditForm.recordNumber,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
           // 执行处理页面显示方法
           this.fun_GetHandle();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
        // 加载框取消
        this.fullLoading.close();
      })
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading() {
      this.fullLoading = this.$loading({
        lock: true,
        text: "正在进行加载，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
       // 赋值
       this.form[i] = e;
    },
    /**
     * 需要处理页面显示逻辑代码
     */
    fun_GetHandle() {
      // 遍历查询表单
      this.formConfigList.map(form => {
        // 遍历标签页内表单
        form.formConfigList.map(e => {
          // 如果是工程小类
          if (e.value === "prjCategory") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: this.form.prjLargeClass
            };
          }
           // 如果是项目行业分类
          else if (e.value === "industryCode") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/industryCode/IndustryCodeCombobox",
              industryId: this.form.industryClass,
              flag: 0
            };
          }
        });
      });
    },
    /**
    * 提交方法
    * @author liutong
    */
    fun_Audit(state) {
      // 遍历
      this.formConfigList.map(val=>{
        val.formConfigList.map(e=>{
          // 判断是否为核验
          if(e.value === "auditOpinion"){
            // 取消验证
            e.rule[0].required = state === 'tg' ? false : true;
          }
        })
      })
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 判断验证
        if(valid){
          // 状态
          this.auditForm.state = state;
          // 提交的方法
          this.fun_Submit();
        }else{
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
        }
      })
    },
    /**
     * 核验操做
     */
    fun_Submit() {
      // 提示
      let msg = this.auditForm.state === "tg" ? "通过" : "退回";
      // 弹出询问confirm
      this.$confirm("是否确定核验" + msg + "？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 打开遮罩
        this.fun_Loading();
        // 核验意见
        this.auditForm.auditContent = this.form.auditOpinion;
        // 发起请求
        fun_PostAction("/auditProcess/audit", this.auditForm).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
        });
      }).catch(err => {
        console.log(err);
      })
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
  }
};
